/* eslint-disable no-unused-vars */
import React from "react";
import ReactSelect from "react-select";
import { useField } from "formik";
import { useTheme } from "../../../context/ThemeContext";
import { useTranslation } from "react-i18next";

const Dropdown = (props) => {
  const [field, meta, helpers] = useField(props);
  const { theme } = useTheme();

  const { t } = useTranslation();

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: props.minHeight,
      height: props.height,
      borderRadius: props.borderRadius || theme.borderRadius,
      background: "inherit",
      border: state.isFocused
        ? `1px solid ${theme.secondaryColor}`
        : "1px solid #cacaca",

      boxShadow: state.isFocused ? `0 0 2px ${theme.secondaryColor}` : "none",
      "&:hover": {
        borderColor: theme.secondaryColor,
        boxShadow: `0 0 2px ${theme.secondaryColor}`,
      },
    }),
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      color: isDisabled ? "grey" : "black",
      background: isSelected ? "#ebebeb" : "white",
      ":hover": {
        background: isDisabled ? "white" : "#F3F3F3",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#000000",
      fontWeight: "600",
    }),
    placeholder: (provided) => ({
      ...provided,
      whiteSpace: "nowrap",
      fontSize: "14px",
      // fontWeight: "600",
      color: "rgb(202, 202, 202)",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "white",
      fontSize: "14px",
      overflow: "hidden",
      position: "absolute",
      border: "1px solid #CACACA",
      boxShadow: "0 !important",
      "&:hover": {
        border: "1px solid #CACACA",
      },
    }),
    menuList: (provided) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#FFFFFF",
      fontWeight: "normal",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#4B93FF",
      borderRadius: theme.borderRadius, // "20px",
      color: "#FFFFFF",
      marginLeft: "2px",
    }),

    input: (data) => ({
      ...data,
      "input:focus": {
        boxShadow: "none",
      },
      boxShadow: "0 !important",
      "&:hover": {
        border: "0 !important",
      },
    }),
    //Required to show full dropdown at the end of the page
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    multiValueRemove: (base) => ({
      ...base,
      backgroundColor: "#4B93FF",
      color: "white",
      borderTopRightRadius: theme.borderRadius, // "20px",
      borderBottomRightRadius: theme.borderRadius, // "20px",
      "&:hover": {
        backgroundColor: "#4B93FF",
        color: "white",
      },
    }),
  };

  return (
    <div>
      <ReactSelect
        aria-label={props.name}
        className={`input ${props.className} ${
          meta.touched && meta.error && "is-danger"
        }`}
        options={props.options}
        onFocus={props.onFocus}
        isSearchable={props.isSearchable}
        styles={customSelectStyles}
        isMulti={props.isMulti ? props.isMulti : false}
        maxMenuHeight={props.maxMenuHeight}
        menuPlacement={props.menuPlacement ? props.menuPlacement : "bottom"}
        name={props.name}
        getOptionLabel={props.getOptionLabel}
        isDisabled={props.disabled ? props.disabled : null}
        isLoading={props.isLoading ? props.isLoading : null}
        onChange={props.onChange}
        onInputChange={props.onInputChange ? props.onInputChange : null}
        defaultValue={props.defaultValue ? props.defaultValue : null}
        value={
          props.options
            ? props.isMulti
              ? (field.value || [])
                  .map((val) =>
                    props.options.find((option) => option.value === val)
                  )
                  .filter(Boolean)
              : field.value
              ? props.options.find((option) => option.value === field.value) || null
              : null
            : null
        }
        placeholder={props.placeholder}
        //Required to show full dropdown at the end of the page
        menuPortalTarget={document.body}
        onBlur={props.onBlur}
        components={{
          IndicatorSeparator: () => null,
        }}
        noOptionsMessage={() => t("_No_Options")}
        loadingMessage={() => t("_.Loading")}
      />
    </div>
  );
};

export default Dropdown;
